const partner_type = {
  PARTNER_LOGIN_PAGE_IMAGE: "partner_login_page_image",
  PARTNER_SIGNUP_PAGE_IMAGE: "partner_signup_page_image"
};
export default partner_type;
